module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('text-input', {
    attrs: {
      "label": _vm.label,
      "prop": _vm.prop,
      "required": _vm.required,
      "type": "number",
      "step": _vm.step,
      "decimals": 0,
      "size": _vm.size,
      "align-input": "right",
      "min": _vm.min,
      "max": _vm.max,
      "prefix": _vm.prefix,
      "suffix": _vm.suffix,
      "is-prefix-icon": _vm.isPrefixIcon,
      "is-suffix-icon": _vm.isSuffixIcon,
      "disabled": _vm.disabled,
      "no-form": _vm.noForm,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": function($event) {
        _vm.v = parseFloat($event)
      },
      "change": _vm.updated
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b34788c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/IntegerInput.vue
// module id = 1548
// module chunks = 0